import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP1FloorBudgetNew202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p1_floor_budget_new_202605",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 41,
  clicks: 1,
  adsSpendDollars: 2,
  budgetDollars: 200,
  salesDollars: 0,
  bestEstimateRoas: 0,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.01,
  newCustomersAcquired: 0,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
